// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zx0O8","rootMobile":"styles_rootMobile__11hIP"};